// extracted by mini-css-extract-plugin
export default {"button":"Anchor-module__button__u2BH8"};